import { FieldBlock, Input } from '@orbind/ui'

/**
 * Pecas compartilhadas pelas telas de catalogo do admin (SPEC-20260815-0821):
 * paleta de cores do prototipo, card de interruptor e campo de cor. Mantem os
 * formularios FormScreen consistentes sem cada tela reinventar o basico.
 */

/** Paleta dos campos de cor (mesma do protótipo/AdminPage). */
export const CATALOG_COLORS: readonly { readonly value: string; readonly label: string }[] = [
  { value: '#1B4DF5', label: 'Azul' },
  { value: '#0E9AE0', label: 'Azul-claro' },
  { value: '#19B27B', label: 'Verde' },
  { value: '#E0A106', label: 'Âmbar' },
  { value: '#D93A3A', label: 'Vermelho' },
  { value: '#6C5CE7', label: 'Roxo' },
  { value: '#E07A5F', label: 'Terracota' },
  { value: '#8A93B8', label: 'Cinza-azulado' },
]

/** "Atendimento ao Empresa" -> "ATENDIMENTO_AO_CLIENTE". */
export function normalizarCodigo(texto: string) {
  return texto
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[^A-Za-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toUpperCase()
}

/** Card com interruptor e explicacao do efeito (padrao vindo de Areas). */
export function SwitchCard({
  title,
  description,
  checked,
  onChange,
  disabled,
}: {
  title: string
  description: string
  checked: boolean
  onChange: (proximo: boolean) => void
  disabled?: boolean
}) {
  return (
    <div className="adm-switchcard">
      <span className="adm-switchcard__text">
        <strong>{title}</strong>
        <small>{description}</small>
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={title}
        disabled={disabled}
        className={`adm-switch${checked ? ' adm-switch--on' : ''}`}
        onClick={() => onChange(!checked)}
      >
        <span className="adm-switch__knob" aria-hidden />
      </button>
    </div>
  )
}

/** Seletor de cor: paleta do protótipo + opcao "sem cor". Nome sempre junto. */
export function ColorField({
  label = 'Cor',
  hint,
  value,
  onChange,
}: {
  label?: string
  hint?: string
  value: string | null
  onChange: (cor: string | null) => void
}) {
  const atual = CATALOG_COLORS.find((c) => c.value.toLowerCase() === (value ?? '').toLowerCase())
  return (
    <FieldBlock label={label} hint={hint ?? `Apoio visual — nunca substitui o rótulo. ${atual ? `Atual: ${atual.label}.` : value ? `Atual: ${value}.` : 'Sem cor.'}`}>
      {() => (
        <div className="adm-colorpick" role="group" aria-label={label}>
          <button
            type="button"
            className={`adm-colorpick__none${value === null ? ' adm-colorpick__none--on' : ''}`}
            title="Sem cor"
            aria-pressed={value === null}
            onClick={() => onChange(null)}
          >
            <i className="fas fa-ban" aria-hidden />
          </button>
          {CATALOG_COLORS.map((cor) => (
            <button
              key={cor.value}
              type="button"
              className={`adm-colorpick__swatch${
                (value ?? '').toLowerCase() === cor.value.toLowerCase() ? ' adm-colorpick__swatch--on' : ''
              }`}
              style={{ background: cor.value }}
              title={cor.label}
              aria-label={cor.label}
              aria-pressed={(value ?? '').toLowerCase() === cor.value.toLowerCase()}
              onClick={() => onChange(cor.value)}
            />
          ))}
          <Input
            aria-label="Cor personalizada (hex)"
            placeholder="#RRGGBB"
            value={value ?? ''}
            style={{ width: 110 }}
            onChange={(e) => {
              const bruto = e.target.value.trim()
              if (bruto === '') onChange(null)
              else onChange(bruto.startsWith('#') ? bruto : `#${bruto}`)
            }}
          />
        </div>
      )}
    </FieldBlock>
  )
}
